import { Component, AfterViewInit , OnInit, ElementRef, ViewChild, ComponentFactoryResolver } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { userUsageService } from '../service/userUsage.service';
import { from } from 'rxjs';
import { groupBy, mergeMap, toArray, map } from 'rxjs/operators';
import * as _ from 'lodash';


@Component({
  selector: 'app-data-assessments-component',
  templateUrl: './data-assessments-component.component.html',
  styleUrls: ['./data-assessments-component.component.css'],
  providers: [userUsageService]
})
export class DataAssessmentsComponentComponent implements OnInit {


  assessmentData: any;
  sumofAssessmentItems: any = [];
  assess_data_01 = {
    video: 100,
    Documents: 50,
    Audio: 40,
    eLearningCourses: 10
  };

  assess_settings_01 = {
    selector: '.assICTResultsChart',
    width: 200,
    height: 200,
    hole: 90,
    colors : ['#a56ebe', '#34b07f', '#f78521', '#f2c618']
  };

  constructor() {}

  ngOnInit() {}

  groupDataSum(items: any){
    const source = from(items);
    source.pipe(
      groupBy((x: any) => x._id.assessment_result_in_grades),
      mergeMap(group => group.pipe(toArray())),
      map(g => {
        return {
          name: g[0]._id.assessment_result_in_grades, //take the first name because we grouped them by name
          students: _.sumBy(g, 'no_of_students'), // using lodash to sum quantity
          gradecategory: g[0]._id.grade_category
        };
      }),
      toArray()
    ).subscribe(d => this.sumofAssessmentItems = d);
  }
}
